import * as React from 'react'
import classNames from 'classnames'

export interface LabelProps extends React.ComponentPropsWithoutRef<'div'> {
	color?: 'blue' | 'red' | 'green' | 'yellow' | 'gray' | 'white'
	size?: 'sm' | 'md' | 'lg' | 'full'
	pointer?: boolean
}

const Tag = React.forwardRef<HTMLDivElement, LabelProps>(
	({ children, color = 'blue', size = 'full', pointer = false }, forwardedRef) => (
		<div
			ref={forwardedRef}
			className={classNames('flex rounded-2xl items-center justify-center font-medium pointer-events-none gap-1.5', {
				'bg-[#D1EFFC] text-[#29B6F6]': color === 'blue',
				'bg-[#F3DDDB] text-[#F34938]': color === 'red',
				'bg-[#DDF0DD] text-[#66BB6A]': color === 'green',
				'bg-[#FFF7E3] text-[#FFB600]': color === 'yellow',
				'bg-brand-gray-100 text-brand-gray-300': color === 'gray',
				'bg-white text-brand-gray-300 border border-[#EDEDED]': color === 'white',
				'h-6 md:h-8 px-3 py-1 text-[11px] md:text-xs': size === 'sm',
				'h-6 md:h-8 px-4 py-1 text-[11px] md:text-xs': size === 'md',
				'h-6 md:h-8 px-4 py-1 text-[14px]': size === 'lg',
				'h-10 rounded-3xl px-4 text-xs md:text-sm tracking-wider w-full': size === 'full',
				'cursor-pointer': pointer,
				'cursor-default': !pointer,
			})}
		>
			{children}
		</div>
	),
)

Tag.displayName = 'Label'
export default Tag
